module.exports = __webpack_public_path__ + "img/潜伏AGV.e8063ef4.jpg";